(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('ErrorFactory', ErrorFactory);

	ErrorFactory.$inject = ['$rootScope', '$state']

	function ErrorFactory($rootScope, $state) {

		var error = {};

		function errorPage(errorCode, lang, description, content, custom_msg) {
			content = typeof content !== "undefined" ? content : "";

			$rootScope.currentStep = 'error';
			ErrorFactory.error = {
				code: errorCode,
				lang: lang,
				desc: description,
				content: content,
				custom: custom_msg
			};
			if ($rootScope.ga) {
				$rootScope.ga.serviceErr(errorCode, description);
			}
			$state.go('error');
		}

		function timeout() {
			errorPage("STO");
		}

		var ErrorFactory = {
			errorPage: errorPage,
			error: error,
			timeout: timeout
		}

		return ErrorFactory;

	};

})();
